import { memo, useEffect } from 'react'
import { useAsyncDispatchWithErrorToast } from './hooks/useAsyncDispatchWithErrorToast'
import { FetchDriver, FetchPartner } from './constants/actionTypes'
import { Driver } from './interfaces/driver'

export const ClientSecureHooksContainer = memo(() => {
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast('client')

  useEffect(() => {
    const initUser = async () => {
      try {
        await asyncDispatchWithErrorToast<Driver>(FetchDriver.request(), true)
        await asyncDispatchWithErrorToast(FetchPartner.request(), true)
      } catch {}
    }

    initUser()
  }, [])

  return null
})
